import { useState } from "react";

import { Card } from "@/components/card";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useGetOrganisations } from "@/features/organisations/api/get-organisations";
import { OnboardingHeader } from "@/features/registration/components/onboarding-header";
import { AverageSessionDuration } from "@/features/reporting/components/average-session-duration";
import { BaseAnalytics } from "@/features/reporting/components/base-analytics";
import { Concurrency } from "@/features/reporting/components/concurrency";
import { MostActiveUsers } from "@/features/reporting/components/most-active-users";
import { RoomUsage } from "@/features/reporting/components/room-usage";
import { RoomUsageByRoomSystem } from "@/features/reporting/components/room-usage-by-room-system";
import { ScheduledSessions } from "@/features/reporting/components/scheduled-sessions";

export function OrganisationReporting() {
  const { data: organisations } = useGetOrganisations();
  const [organisationId, setOrganisationId] = useState<string | undefined>(
    undefined,
  );
  return (
    <section>
      <OnboardingHeader
        title="Organisation & Groups"
        description="View analytics per group or organisation"
        className="mb-6"
        actions={
          <div>
            <Select
              value={organisationId}
              onValueChange={setOrganisationId}
              disabled={!organisations}
            >
              <SelectTrigger className="w-60 [&>span]:truncate">
                <SelectValue placeholder="Select organisation" />
              </SelectTrigger>
              <SelectContent>
                {organisations?.map((organisation) => (
                  <SelectItem key={organisation.id} value={organisation.id}>
                    {organisation.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        }
      />
      <div className="space-y-6">
        {!organisationId ? (
          <Card>
            <Card.Content>
              <div className="flex flex-col items-center justify-center gap-2">
                <span className="font-semibold text-foreground">
                  Select an organisation
                </span>
                <p className="text-center text-sm text-muted-foreground">
                  To view analytics for an organisation, select one using the
                  dropdown above
                </p>
              </div>
            </Card.Content>
          </Card>
        ) : (
          <>
            <BaseAnalytics organisationId={organisationId} />
            <Concurrency organisationId={organisationId} />
            <ScheduledSessions organisationId={organisationId} />
            <RoomUsage organisationId={organisationId} />
            <AverageSessionDuration organisationId={organisationId} />
            <RoomUsageByRoomSystem organisationId={organisationId} />
            <MostActiveUsers organisationId={organisationId} />
          </>
        )}
      </div>
    </section>
  );
}
